'use client';

import React from 'react';

import { Button } from '@/components/ui/button';
import { useAuthStore } from '@/presentation/hooks/useStores';

type Props = {
  index: number;
  totalProcess: number;
  onIndexChange: (index: number) => void;
};

const Consent = (props: Props) => {
  const authStore = useAuthStore();
  const userData = authStore.partnerAuthSession?.userData;
  const partnerName = authStore.partnerAuthSession?.partnerCode || 'your provider';

  const handleNext = () => {
    if (props.index === props.totalProcess) {
      return;
    }
    const nextIndex = props.index + 1;
    props.onIndexChange(nextIndex);
  };

  return (
    <>
      <div className="my-5 flex flex-col items-center gap-4 text-center">
        <img
          alt={'receipts'}
          className={'block'}
          src={'/assets/svgs/Receipt.svg'}
        />
        <h1 className="text-2xl font-bold">Access of Information</h1>
        <p className="w-full text-center font-light sm:w-11/12">
          We value your privacy. All information you share will remain secure
          and will never be sold.
        </p>
      </div>
      <div className="my-5 flex w-full flex-col items-center gap-4">
        <div
          className={
            'w-full px-4 py-8 bg-white rounded-[20px] text-center flex flex-col items-center gap-6'
          }
        >
          <p>
            <b>
              {userData?.first_name} {userData?.last_name}
              <br />
            </b>
            Motito Marketplace will securely access your data from {partnerName} to help
            you complete onboarding faster and more easily.
          </p>

          <div className={'w-full'}>
            <Button
              type="button"
              size={'lg'}
              className="btn-primary rounded-full w-full"
              onClick={handleNext}
            >
              I agree, continue
            </Button>
          </div>
          <div>
            <p className={'text-center text-[13px]'}>
              By continuing, you give Motito Marketplace permission to securely
              access your information from {partnerName} in accordance with our privacy
              policy.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Consent;
